module.exports = __webpack_public_path__ + "img/dog-walk-icon.7ca24db7.svg";